module.exports = __webpack_public_path__ + "media/images/top/howto-07-72408312d524ec3d033c9195e4877f11.svg";